module.exports = __webpack_public_path__ + "core-img/alert-bg.34a17e066476a1f38ced1d9a639ae495.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/images/debug-renderer/alert-bg.png
// module id = 76
// module chunks = 0